import { subMonths } from "date-fns";

export const DEFAULT_AMOUNT_OF_MONTHS = 1;

export const DEFAULT_START_END_DATE = {
  startDate: subMonths(new Date(), DEFAULT_AMOUNT_OF_MONTHS),
  endDate: new Date(),
};
